// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const Home = React.forwardRef(function Home(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></SvgIcon>;
});
export default Home;
